export class MapStorage {
    public static map: PIXI.Container;
    public static plus: number = 0;
    public static lastLevel: number = 0;
    public static screenHeight: number = 0;
}